<div class="modal-header">
  <div class="h5-text modal-title w-100" id="NoPortfolioModal">Welcome to The Nicola Wealth Client Portal</div>
  <button type="button" class="close" (click)="activeModal.dismiss('Cross click')" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <p>Thank you for completing the registration process.</p>
  <p>This login is not associated with any portfolios.
     Please reach out to our client services team for support at <a href="mailto:clientservices@nicolawealth.com">clientservices&#64;nicolawealth.com</a>.
  </p>
</div>
